'use strict';

exports.__esModule = true;
exports.default = undefined;

var _Animate = require('./Animate');

var _Animate2 = _interopRequireDefault(_Animate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Animate2.default; /* eslint-disable flowtype/require-valid-file-annotation */


//////////////////
// WEBPACK FOOTER
// ./~/react-move/Animate/index.js
// module id = 391
// module chunks = 95715928098905 128049163870319 241767136424496